import request from '@apps-common/js-client/api/request';

import {DATA_API_URL} from '@explorer/config';

export const getItemTypes = () =>
  request
    .get(`${DATA_API_URL}/item-types`)
    .then(response => response.data.item_types);

export const getItem = ({itemType, itemId}) =>
  request
    .get(`${DATA_API_URL}/item-types/${itemType}/items/${itemId}`)
    .then(response => response.data);
